<template>
  <div class="d-flex align-center" style="height: 28px; width: 30px">
    <v-icon color="grey-lighten-1" @click="goBack">
      mdi-arrow-u-left-top
    </v-icon>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import type { RouteLocationRaw } from 'vue-router'

export default defineComponent({
  props: {
    /** 지정 시 브라우저 히스토리 대신 해당 경로로 이동 */
    to: {
      type: [String, Object] as PropType<RouteLocationRaw>,
      default: null,
    },
    replace: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    goBack() {
      if (this.to) {
        const navigate = this.replace ? this.$router.replace : this.$router.push
        navigate.call(this.$router, this.to).catch(() => {})
        return
      }
      this.$router.go(-1)
    },
  },
})
</script>
